const useUserPremiumCheck = () => {
  const { user } = useAgsUser()
  const isUserPremium = computed(
    () => user.value?.groups?.includes('premium') ?? false,
  )
  return { isUserPremium }
}

export default useUserPremiumCheck
